module.exports = __webpack_public_path__ + "img/application-graphic.bdf1717b.png";